import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

/**
 * Ciuffo grande della nuance corrente, accanto alla galleria (fuori dal carosello).
 *
 * Si aggiorna col PATTERN del tema (come product-price.js e media-gallery.js): ascolta
 * `variant:update` sulla sezione e pesca il pezzo fresco dal `event.detail.data.html`
 * (il documento rigenerato dal server). Nessuna costruzione di URL in JS: l'immagine
 * giusta è già resa lato server con `asset_url` e la nuance nuova.
 *
 * @extends {Component}
 */
class ProductNuanceCiuffo extends Component {
  /** @type {HTMLElement | null} */
  #section = null;

  connectedCallback() {
    super.connectedCallback();
    this.#section = this.closest('.shopify-section');
    this.#section?.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
    this.#guardImage();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#section?.removeEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  /**
   * @param {CustomEvent} event - variant:update
   */
  #onVariantUpdate = (event) => {
    const html = event.detail?.data?.html;
    if (!html) return;

    const fresh = html.querySelector('product-nuance-ciuffo');
    // Se la nuova nuance non ha ciuffo, `fresh` è senza <img> → l'elemento resta vuoto (niente immagine).
    this.replaceChildren(...(fresh ? Array.from(fresh.cloneNode(true).childNodes) : []));
    this.#guardImage();
  };

  /**
   * Se l'immagine non carica (file mancante), la rimuove: niente immagine rotta.
   */
  #guardImage = () => {
    const img = this.querySelector('img');
    if (img) img.addEventListener('error', () => img.remove(), { once: true });
  };
}

if (!customElements.get('product-nuance-ciuffo')) {
  customElements.define('product-nuance-ciuffo', ProductNuanceCiuffo);
}
